import React from "react";

const SpeakersCard = (prop) => {
  return (
    <div className="bg-[#f1f1f5] text-[#000] p-2  mb-6 rounded-md flex  lg:flex-row 3xl:flex-col 4xl:flex-row  flex-col gap-4 lg:w-[38rem] 3xl:w-full">
      <div className=" w-full h-[20rem] lg:w-[20rem] lg:h-[20rem]">
        <img
          src={prop.speaker1}
          className="w-[30rem] h-[20rem] lg:w-full lg:h-full"
          alt=""
        />
      </div>
      <div className="w-full lg:w-[20rem] flex flex-col gap-[2rem]">
        <div className="flex flex-col">
          <span className="text-xl">{prop.name1}</span>
          <span className="font-thin text-sm mt-[0.2rem]">{prop.place1}</span>
        </div>
        <div>
          <span className="font-semibold">Title of Talk: </span>
          {prop.note1}
        </div>
      </div>
    </div>
  );
};

export default SpeakersCard;
